<div [formGroup]="formGroup">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
    <div class="col-span-1 md:col-span-2">
      <label for="context" class="font-medium"
        >Contexte <span class="text-red-500">*</span></label
      >
      <input
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        pInputText
        formControlName="context"
        class="w-full text-base mt-2 border-2 rounded-xl appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('context'),
          'border-gray-200': !getFieldError('context'),
        }"
      />
      <small
        *ngIf="getFieldError('context')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("context") }}</small
      >
    </div>

    <div class="col-span-1 md:col-span-2">
      <label for="behaviorSummary" class="font-medium"
        >Résumé du comportement</label
      >
      <textarea
        [ind4RoleDisabled]="'SED_PLUS_REGULAR_USER'"
        formControlName="behaviorSummary"
        id="behaviorSummary"
        placeholder="Laissez vide si vous souhaitez une description générée par l'IA."
        class="w-full text-base p-2 mt-2 appearance-none outline-none overflow-y-auto"
        style="min-height: 100px; max-height: 300px"
      ></textarea>
    </div>

    <div class="col-span-1 md:col-span-2">
      <label for="weeksBeforeFailure" class="font-medium"
        >Semaines avant défaillance :</label
      >
      <p-inputNumber
        [ind4RoleDisabled]="'SED_PLUS_REGULAR_USER'"
        formControlName="weeksBeforeFailure"
        placeholder="Nombre de semaines"
        [min]="1"
        [max]="999"
        [showButtons]="true"
        class="w-full"
      ></p-inputNumber>
    </div>

    <div>
      <label for="stage" class="font-medium"
        >Maturité <span class="text-red-500">*</span></label
      >
      <p-select
        formControlName="stage"
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        [options]="stageOptions"
        placeholder="Sélectionnez une option"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 border-gray-200 rounded-xl focus:border-blue-500 appearance-none outline-none"
      ></p-select>
      <small *ngIf="hasActiveEvaluation" class="block mt-1 text-orange-600">
        {{ stageTooltipMessage }}
      </small>
      <small *ngIf="prodStageValidationMessage" class="block mt-1 text-red-600">
        {{ prodStageValidationMessage }}
      </small>
    </div>

    <div>
      <label for="criticality" class="font-medium"
        >Criticité <span class="text-red-500">*</span></label
      >
      <p-select
        formControlName="criticality"
        [options]="criticalityOptions"
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        placeholder="Sélectionnez une option"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 rounded-xl focus:border-blue-500 appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('criticality'),
          'border-gray-200': !getFieldError('criticality'),
        }"
      ></p-select>
      <small
        *ngIf="getFieldError('criticality')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("criticality") }}</small
      >
    </div>

    <div class="col-span-1 md:col-span-2">
      <label for="isActive" class="font-medium"
        >État <span class="text-red-500">*</span></label
      >
      <p-select
        formControlName="isActive"
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        [options]="stateOptions"
        placeholder="Sélectionnez une option"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 border-gray-200 rounded-xl focus:border-blue-500 appearance-none outline-none"
      ></p-select>
    </div>
  </div>
</div>
